var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "columns is-centered" }, [
        _c("div", { staticClass: "column is-half" }, [
          _c(
            "form",
            { ref: "form" },
            [
              _c(
                "b-field",
                { attrs: { label: "Email" } },
                [
                  _c("b-input", {
                    attrs: {
                      type: "email",
                      value: "example@",
                      maxlength: "256",
                      required: ""
                    },
                    model: {
                      value: _vm.mail,
                      callback: function($$v) {
                        _vm.mail = $$v
                      },
                      expression: "mail"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-field",
                { attrs: { label: "Password" } },
                [
                  _c("b-input", {
                    attrs: {
                      type: "password",
                      value: "iwantmytreasure",
                      "password-reveal": "",
                      required: ""
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { size: "is-large", disabled: _vm.isDisabled },
                  on: { click: _vm.login }
                },
                [_vm._v("ログイン")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("b-loading", {
        staticStyle: { "background-color": "rgba(0, 0, 0, 0.8)" },
        attrs: { "is-full-page": true, "can-cancel": false },
        model: {
          value: _vm.isLoading,
          callback: function($$v) {
            _vm.isLoading = $$v
          },
          expression: "isLoading"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-534adaec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-534adaec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminLogin.vue
// module id = mxx8
// module chunks = 0